/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/083-stopwatch': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 3.019V2h2V1a1 1 0 00-1-1H6a1 1 0 00-1 1v1h2v1.019a6.5 6.5 0 101 0zm3.036 10.017c-.944.944-2.2 1.464-3.536 1.464s-2.591-.52-3.536-1.464C3.02 12.092 2.5 10.836 2.5 9.5s.52-2.591 1.464-3.536a4.967 4.967 0 013.377-1.462l-.339 4.907c-.029.411.195.591.497.591s.527-.18.497-.591l-.339-4.907c1.276.04 2.47.555 3.377 1.462.944.944 1.464 2.2 1.464 3.536s-.52 2.591-1.464 3.536z"/>'
  }
})
